import { createQaApi } from "@org-avp/avp-avengers-qa-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const baseQueryArgs: Parameters<typeof fetchBaseQuery>[0] = {
  baseUrl: environment.NX_QA_SERVICE_BASE_URL,
  prepareHeaders,
};

export const qaApi: ReturnType<typeof createQaApi> = createQaApi({
  baseQueryArgs,
});
